import React from "react";
import { Col, Row, Select } from "antd";
import { Controller } from "react-hook-form";
import ProfileForm from "../../../../../components/profile-form/profile-form";
import { institutionType } from "../../../../../constants/common";

const InstituteRegulatoryAcademic = ({ control, isEditMode }) => {
  return (
    <Row style={{ margin: "20px 0" }} gutter={[32, 16]}>
      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="education_authority"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.TextInput
              isEdit={isEditMode}
              inputLabel="Education Authority / Ministry"
              placeholder="Enter name"
              required
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="levels_offered"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.TextInput
              isEdit={isEditMode}
              inputLabel="Levels Offered"
              placeholder="Enter levels"
              required
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="total_students"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.TextInput
              isEdit={isEditMode}
              inputLabel="Number of Students"
              placeholder="Enter number"
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="total_teachers"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.TextInput
              isEdit={isEditMode}
              inputLabel="Number of Teachers"
              placeholder="Enter number"
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="total_classes"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.TextInput
              isEdit={isEditMode}
              inputLabel="Number of Classes"
              placeholder="Enter number"
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="total_support_staffs"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.TextInput
              isEdit={isEditMode}
              inputLabel="Number of Ancillary/ Support Staff"
              placeholder="Enter number"
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="boarding_or_day"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.Select
              isEdit={isEditMode}
              inputLabel="Boarding or Day"
              placeholder="--Select--"
              required
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            >
              {institutionType.map((item, index) => (
                <Select.Option key={index} value={item?.value}>
                  {item?.label}
                </Select.Option>
              ))}
            </ProfileForm.Select>
          )}
        />
      </Col>
    </Row>
  );
};

export default InstituteRegulatoryAcademic;
